import { useEffect } from "react";
import {
    Link,
    Navigate,
    Outlet,
    RouterProvider,
    createRootRoute,
    createRoute,
    createRouter,
} from "@tanstack/react-router";
import {
    Authenticated,
    Unauthenticated,
    useMutation,
    useQuery,
} from "convex/react";
import { UserButton } from "@clerk/clerk-react";
import { api } from "../convex/_generated/api";
import Landing from "./pages/Landing";
import AgendaPage from "./pages/AgendaPage";
import ConversasPage from "./pages/ConversasPage";
import ClientesPage from "./pages/ClientesPage";
import BarbeirosPage from "./pages/BarbeirosPage";
import ConfigPage from "./pages/ConfigPage";
import AppHeader from "./components/AppHeader";
import PendingWhatsappConfig from "./components/PendingWhatsappConfig";

function EnsureTenant() {
    const ensureTenant = useMutation(
        api.index.tenants_getOrCreateForCurrentUser,
    );
    useEffect(() => {
        ensureTenant({}).catch(() => {});
    }, []);
    return null;
}

function RootLayout() {
    const tenant = useQuery(api.index.tenants_getForCurrentUser);
    return (
        <>
            <Unauthenticated>
                <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-6">
                    <Navigate to="/" />
                    <Landing />
                </div>
            </Unauthenticated>
            <Authenticated>
                <EnsureTenant />
                <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
                    {tenant === undefined ? null : tenant &&
                      !tenant.whatsappNumber ? (
                        <>
                            <AppHeader />
                            <div className="mx-auto max-w-[1600px] px-8 py-6">
                                <PendingWhatsappConfig />
                            </div>
                        </>
                    ) : (
                        <>
                            <AppHeader />
                            <div className="mx-auto max-w-[1600px] px-8 py-6">
                                <Outlet />
                            </div>
                        </>
                    )}
                </div>
            </Authenticated>
        </>
    );
}

const rootRoute = createRootRoute({ component: RootLayout });
const indexRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/",
    component: () => <Navigate to="/agenda" />,
});
const agendaRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/agenda",
    component: AgendaPage,
});
const conversasRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/conversas",
    component: ConversasPage,
});
const clientesRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/clientes",
    component: ClientesPage,
});
const barbeirosRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/barbeiros",
    component: BarbeirosPage,
});
const configRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/config",
    component: ConfigPage,
});

const routeTree = rootRoute.addChildren([
    indexRoute,
    agendaRoute,
    conversasRoute,
    clientesRoute,
    barbeirosRoute,
    configRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

export default function AppRouter() {
    return <RouterProvider router={router} />;
}
